import React from 'react'
import { MainBannerRent } from './components/MainBannerRent'
import { OurBestCars } from './components/OurBestCars'

export const MainRentCar = () => {
  return (
    <>
    <MainBannerRent />
    <OurBestCars />
    </>
  )
}
